import { SubPageLayout } from "@/components/SubPageLayout";
import { SITE_IMAGES } from "@/lib/site-data";

export default function EltetoArnyekolo() {
  return (
    <SubPageLayout
      eyebrow="Előtető, árnyékoló"
      title="Teraszárnyékolás, ami évekig kitart."
      intro="Fix vagy nyitható szerkezetű napellenzők és előtetők, teraszok téliesítése strapabíró PVC ponyvából. 2 év EU-s szabványos garanciával."
      heroImage="/assets/gallery/terasz-telisites.jpg"
      bullets={[
        { title: "100% vízhatlan", text: "PVC-alapú ponyva – sosem ázik át, könnyen tisztítható." },
        { title: "Cserélhető", text: "Meglévő nyitható napellenző textiljét lecseréljük PVC-re." },
        { title: "Téliesítés", text: "Ablakos vagy ablak nélküli oldalfalak teraszának zárására." },
      ]}
      gallery={SITE_IMAGES.awningGallery}
    >
      <section className="py-16 md:py-24 bg-white">
        <div className="max-w-5xl mx-auto px-4 md:px-8">
          <div className="bg-[#F8FAFC] border-l-4 border-[#EA580C] p-6 md:p-8 rounded-md">
            <h3 className="font-heading font-bold text-[#0B192C] text-xl">
              Miért PVC, és nem szövet?
            </h3>
            <p className="mt-3 text-gray-600 text-sm md:text-base leading-relaxed">
              A barkácsáruházi szövet napellenzők gyorsan koszolódnak,
              tisztításuk drága. Mi kizárólag kamion-minőségű, strapabíró
              élettartamú PVC ponyvából dolgozunk – ezért tudunk valós
              garanciát adni.
            </p>
          </div>
        </div>
      </section>
    </SubPageLayout>
  );
}
